<template>
  <div class="text-left pb-10">
    <h1 class="font-weight-black text-h4 my-4">Équipe de la cantine</h1>
    <p class="body-1">
      Les agents associés à cette cantine y tiennent un ou plusieurs rôles. Ils reçoivent une invitation par email et
      doivent confirmer leur association avec un code.
    </p>

    <v-list v-if="staff.length > 0">
      <ManagerItem @delete="deleteMember" v-for="member in staff" :key="member.email" :manager="member" />
    </v-list>

    <v-list v-if="staffInvitations && staffInvitations.length > 0">
      <p class="text-body-1 font-weight-black">Invitations en cours</p>
      <ManagerItem @delete="deleteMember" v-for="invite in staffInvitations" :key="invite.email" :manager="invite" />
    </v-list>

    <p v-if="staff.length === 0 && (!staffInvitations || staffInvitations.length === 0)" class="grey--text mt-4">
      Aucun membre pour l'instant.
    </p>

    <v-row class="mt-4">
      <v-col cols="12" sm="10" md="8">
        <v-form ref="staffForm" v-model="staffFormIsValid" v-on:submit.prevent="addMember">
          <p class="body-2 mb-2 text-left grey--text text--darken-1">Inviter un agent et lui donner un rôle</p>
          <div class="d-sm-flex align-sm-start flex-wrap">
            <DsfrEmail
              v-model="newMemberEmail"
              label="Adresse électronique"
              :rules="[validators.emailOrEmpty]"
              class="flex-grow-1 mb-sm-6 mr-sm-4"
            />
            <v-select
              v-model="newMemberJob"
              :items="jobChoices"
              item-text="label"
              item-value="value"
              label="Rôle"
              outlined
              dense
              class="mb-sm-6 mr-sm-4"
              style="max-width: 200px;"
            />
            <v-btn
              @click="addMember"
              outlined
              color="primary darken-1"
              class="ml-sm-0"
              large
              :disabled="!newMemberEmail || !newMemberJob"
            >
              Inviter
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ManagerItem from "./ManagerItem"
import Constants from "@/constants"
import validators from "@/validators"
import DsfrEmail from "@/components/DsfrEmail"

export default {
  name: "CanteenStaff",
  components: { ManagerItem, DsfrEmail },
  props: {
    originalCanteen: {
      type: Object,
      required: true,
    },
  },
  created() {
    document.title = `Équipe - ${this.originalCanteen.name} - ${this.$store.state.pageTitleSuffix}`
  },
  data() {
    return {
      staffFormIsValid: true,
      newMemberEmail: null,
      newMemberJob: "SUPERVISOR",
      // Référentiel unique des rôles rattachables (miroir du pivot côté back).
      jobChoices: Constants.StaffJobs,
    }
  },
  computed: {
    validators() {
      return validators
    },
    staff() {
      return this.originalCanteen.staff || []
    },
    staffInvitations() {
      return this.originalCanteen.staffInvitations || []
    },
  },
  methods: {
    addMember() {
      this.$refs.staffForm.validate()
      if (!this.staffFormIsValid) {
        this.$store.dispatch("notifyRequiredFieldsError")
        return
      }
      this.$store
        .dispatch("addStaff", {
          canteenId: this.originalCanteen.id,
          email: this.newMemberEmail.trim(),
          job: this.newMemberJob,
        })
        .then((staffTeam) => {
          this.$store.dispatch("notify", {
            title: "Invitation envoyée",
            message: `${this.newMemberEmail} a bien été invité(e)`,
            status: "success",
          })
          this.newMemberEmail = null
          this.originalCanteen.staff = staffTeam["staff"]
          this.originalCanteen.staffInvitations = staffTeam["staffInvitations"]
        })
        .catch((e) => {
          this.$store.dispatch("notifyServerError", e)
        })
    },
    deleteMember(member) {
      this.$store
        .dispatch("removeStaff", {
          canteenId: this.originalCanteen.id,
          email: member.email.trim(),
        })
        .then((staffTeam) => {
          this.$store.dispatch("notify", {
            title: "Membre retiré",
            message: `${member.email} n'est plus associé(e) à cette cantine`,
            status: "success",
          })
          this.originalCanteen.staff = staffTeam["staff"]
          this.originalCanteen.staffInvitations = staffTeam["staffInvitations"]
        })
        .catch((e) => {
          this.$store.dispatch("notifyServerError", e)
        })
    },
  },
}
</script>
